// extracted by mini-css-extract-plugin
module.exports = {"auth-footer-redirect":"authFooterRedirect_auth-footer-redirect__3bQ63"};